export default __webpack_public_path__ + "static/media/ONE-STATE.80c6d859.jpg";